import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Translator from "../../Translation/Translator";

export default function* contractSign(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_SIGN_REQUEST
    });

    const res = yield call(Http.post, `contract/${action.payload?.id}/sign`);

    const contract: ContractInterface = ContractFactory.create(res.data);

    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_SUCCESS,
      payload: {
        contract: contract
      }
    });

    if (!action.payload?.hideSnackbar) { 
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-contract-updated-successfully"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, contract);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_SIGN_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractSign() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_SIGN_START, contractSign);
}
